package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PersonHeartW500Rounded: ImageVector
    get() {
        if (_personHeartW500Rounded != null) {
            return _personHeartW500Rounded!!
        }
        _personHeartW500Rounded = Builder(name = "PersonHeartW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.0f, 721.2f)
                close()
                moveTo(220.41f, 578.65f)
                quadToRelative(62.72f, -31.24f, 127.67f, -46.98f)
                quadToRelative(64.94f, -15.74f, 131.92f, -15.74f)
                quadToRelative(4.48f, 0.0f, 8.2f, -0.61f)
                quadToRelative(3.71f, -0.62f, 8.26f, 0.61f)
                quadToRelative(19.32f, 4.96f, 28.42f, 22.83f)
                quadToRelative(9.1f, 17.87f, 2.9f, 37.02f)
                quadToRelative(-6.19f, 19.15f, -23.08f, 26.01f)
                quadToRelative(-16.9f, 6.86f, -36.53f, 5.38f)
                quadToRelative(-52.56f, -3.47f, -104.63f, 12.03f)
                quadToRelative(-52.06f, 15.5f, -100.67f, 40.3f)
                quadToRelative(-9.0f, 4.89f, -14.5f, 13.7f)
                quadToRelative(-5.5f, 8.81f, -5.5f, 19.58f)
                verticalLineToRelative(28.42f)
                horizontalLineToRelative(252.61f)
                quadToRelative(22.39f, 0.0f, 33.82f, 14.17f)
                quadToRelative(11.44f, 14.17f, 11.68f, 31.33f)
                quadToRelative(0.24f, 16.91f, -11.2f, 31.2f)
                quadToRelative(-11.43f, 14.3f, -34.3f, 14.3f)
                lineTo(242.87f, 812.2f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-29.61f)
                quadToRelative(0.0f, -36.23f, 18.74f, -66.59f)
                quadToRelative(18.74f, -30.37f, 49.8f, -46.35f)
                close()
                moveTo(361.14f, 426.66f)
                quadToRelative(-49.27f, -49.27f, -49.27f, -118.86f)
                quadToRelative(0.0f, -69.58f, 49.27f, -118.74f)
                quadToRelative(49.27f, -49.15f, 118.86f, -49.15f)
                reflectiveQuadToRelative(118.86f, 49.15f)
                quadToRelative(49.27f, 49.16f, 49.27f, 118.74f)
                quadToRelative(0.0f, 69.59f, -49.27f, 118.86f)
                quadToRelative(-49.27f, 49.27f, -118.86f, 49.27f)
                reflectiveQuadToRelative(-118.86f, -49.27f)
                close()
                moveTo(534.47f, 362.28f)
                quadToRelative(22.66f, -22.65f, 22.66f, -54.47f)
                quadToRelative(0.0f, -31.81f, -22.65f, -54.35f)
                quadToRelative(-22.66f, -22.55f, -54.47f, -22.55f)
                reflectiveQuadToRelative(-54.48f, 22.55f)
                quadToRelative(-22.66f, 22.54f, -22.66f, 54.35f)
                quadToRelative(0.0f, 31.82f, 22.65f, 54.47f)
                quadToRelative(22.66f, 22.65f, 54.47f, 22.65f)
                reflectiveQuadToRelative(54.48f, -22.65f)
                close()
                moveTo(480.0f, 307.8f)
                close()
                moveTo(718.15f, 571.83f)
                quadToRelative(20.77f, -20.7f, 37.9f, -35.19f)
                quadToRelative(17.13f, -14.49f, 47.23f, -14.49f)
                quadToRelative(38.42f, 0.0f, 61.63f, 26.37f)
                quadToRelative(23.22f, 26.37f, 23.22f, 59.47f)
                quadToRelative(0.0f, 15.51f, -6.24f, 31.11f)
                reflectiveQuadToRelative(-18.72f, 28.07f)
                lineTo(750.22f, 780.13f)
                quadToRelative(-13.76f, 13.67f, -32.11f, 13.67f)
                reflectiveQuadToRelative(-32.02f, -13.67f)
                lineTo(573.13f, 667.17f)
                quadToRelative(-13.24f, -13.24f, -19.1f, -28.79f)
                quadToRelative(-5.86f, -15.56f, -5.86f, -31.12f)
                quadToRelative(0.0f, -33.19f, 23.85f, -59.15f)
                reflectiveQuadToRelative(61.18f, -25.96f)
                quadToRelative(29.04f, 0.0f, 45.61f, 13.46f)
                quadToRelative(16.56f, 13.45f, 39.34f, 36.22f)
                close()
            }
        }
        .build()
        return _personHeartW500Rounded!!
    }

private var _personHeartW500Rounded: ImageVector? = null
